import React from "react";

const TypingIndicator = () => {
    return (
        <div className="typing-indicator">
            <div className="typing-dot"></div>
            <div className="typing-dot"></div>
            <div className="typing-dot"></div>
        </div>
    );
};

export default TypingIndicator;
